import script from "./MyAccountBank.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAccountBank.vue?vue&type=script&setup=true&lang=js"

import "./MyAccountBank.vue?vue&type=style&index=0&id=5b59cf6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b59cf6a"]])

export default __exports__